export default {
  state: {
    specializeReport: {
      show: false
    },
    directBill: {
      show: false
    },
    driverPayouts: {
      show: false
    }
  },
  mutations: {
    setShowSpecializeReport (state, value) { state.specializeReport.show = value },
    setShowDirectBill (state, value) { state.directBill.show = value },
    setDriverPayouts (state, value) { state.driverPayouts.show = value }
  }
}



// WEBPACK FOOTER //
// ./src/store/reports/reports-specialize.js